// O periodo da pagina de analytics: dias de calendario no fuso de quem ve (plano da entrega 6 do
// RPAA-286, D5). O backend recebe as datas e o fuso e faz as contas das horas; aqui escolhem-se as
// datas, e o `timeIn` so escreve no fuso de quem ve a hora de um instante que o backend mandou.

import { LOCALES } from "../components/charts/format";

export const browserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

// A data de hoje no fuso dado, como AAAA-MM-DD, montada parte a parte como o nowInLisbonNaiveIso do
// productCards.js: a forma que o en-CA escreve nao e garantida entre motores, e uma data mal formada
// fazia o addDays rebentar a desenhar a pagina. O en-CA fica pelos algarismos latinos.
export const todayIn = (timeZone, now = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(now);
  const part = (type) => parts.find((item) => item.type === type).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
};

// AAAA-MM-DD mais `days` dias. A conta faz-se em UTC, onde um dia tem sempre 24 horas.
export const addDays = (isoDate, days) => {
  const [year, month, day] = isoDate.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
};

export const TODAY = "today";
export const PRESETS = [TODAY, 7, 30, 90];

// A hora de um instante no fuso dado, "17:30" em 24 horas nas duas linguas (o en-GB e o pt-PT escrevem-na igual).
export const timeIn = (iso, timeZone, language) =>
  new Intl.DateTimeFormat(LOCALES[language] || language, { timeZone, hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(new Date(iso));

// O Hoje e um periodo de um dia, hoje, e e a excecao a regra seguinte: compara com ontem cortado na mesma
// hora (item 12) e nao com dias inteiros. Os outros: os ultimos `days` dias inteiros, a acabar ontem
// (decidido pelo Tiago). Com hoje incluido o periodo tinha `days` - 1 dias inteiros e um dia por acabar, e
// o anterior do backend tem sempre `days` dias inteiros: com a comparacao ligada os numeros ficavam abaixo
// do anterior, e a ultima barra diaria, incompleta, parecia uma descida.
export const presetPeriod = (preset, timeZone, now = new Date()) => {
  if (preset === TODAY) {
    const today = todayIn(timeZone, now);
    return { from: today, to: today };
  }
  const days = preset;
  const to = addDays(todayIn(timeZone, now), -1);
  return { from: addDays(to, -(days - 1)), to };
};

// O periodo anterior com o mesmo numero de dias, como o Period.previous do backend: a barra diz com que
// datas compara antes de o resumo chegar.
export const previousPeriod = ({ from, to }) => {
  const days = Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86400000) + 1;
  return { from: addDays(from, -days), to: addDays(from, -1) };
};

// O anterior so serve de comparacao quando comeca no primeiro dia com dados ou depois (decidido pelo
// Tiago a 15-Out). Um anterior que comeca antes tem so uma parte dos dias contados, e a variacao contra
// ele parecia um crescimento que nao houve: as variacoes dizem "sem comparacao", como num anterior a zero
// (spec do redesign, R5). `sinceDay` e o primeiro dia com dados no fuso de quem ve, AAAA-MM-DD.
export const previousIsComplete = (period, sinceDay) => previousPeriod(period).from >= sinceDay;

// Os limites do backend (D5): nenhuma data antes de MIN_DATE, e no maximo 366 dias num periodo. O
// calendario so oferece o que o backend aceita: dias de MIN_DATE ate hoje e, com o primeiro dia
// escolhido, ate MAX_DAYS dias a contar dele. As datas AAAA-MM-DD comparam-se como texto.
export const MIN_DATE = "2026-01-01";
export const MAX_DAYS = 366;

export const lastPickableDay = (pickedStart, today) => {
  if (!pickedStart) return today;
  const limit = addDays(pickedStart, MAX_DAYS - 1);
  return limit < today ? limit : today;
};

// O periodo do "Ver desde": comeca no primeiro dia com dados, que e o que o botao diz, e acaba ontem
// (ou nesse mesmo dia, se os dados comecam hoje ou depois). Com mais de MAX_DAYS dias corta-se o fim, e
// nunca o inicio.
export const periodSince = (firstDay, today) => {
  const yesterday = addDays(today, -1);
  const lastDay = yesterday < firstDay ? firstDay : yesterday;
  const limit = addDays(firstDay, MAX_DAYS - 1);
  return { from: firstDay, to: limit < lastDay ? limit : lastDay };
};
